import { NodeSubType } from "../../models/nodeSubType";
import { GroupedOption } from "@bikdotai/bik-component-library/dist/esm/components/dropdown/type";

export enum VOICE_AGENT_TYPE {
  CHECKOUT_RECOVERY_VOICE_AGENT = "CHECKOUT_RECOVERY_VOICE_AGENT",
}

export const VOICE_AGENT_TYPE_OPTIONS: GroupedOption[] = [
  {
    label: "General",
    options: [
      {
        label: "Abandoned Cart",
        value: VOICE_AGENT_TYPE.CHECKOUT_RECOVERY_VOICE_AGENT,
        description: "Agent calls customers to recover abandoned checkouts",
        selected: false,
      },
    ],
  },
];

export enum PAYMENT_MODE {
  PREPAID_ONLY = "prepaid_only",
  PREPAID_AND_COD = "prepaid_and_cod",
}

export enum VOICE_AGENT_OUTCOME {
  COD_ORDER_PLACED = "cod",
  PAYMENT_LINK_REQUESTED = "prepaid",
  CALL_NOT_ATTEMPTED = "callNotAttempted",
  NO_ANSWER = "noAnswer",
  NO_ORDER = "answeredNoOrder",
  COD_ADDR_UNCONFIRMED = 'codAddrUnconfirmed',
  PREPAID_ADDR_UNCONFIRMED = 'prepaidAddrUnconfirmed',
  ADDR_INCOMPLETE = "addressIncomplete",
}

export const VOICE_AGENT_OUTCOMES = [
  {
    id: VOICE_AGENT_OUTCOME.COD_ORDER_PLACED,
    label: "COD order placed",
  },
  {
    id: VOICE_AGENT_OUTCOME.PAYMENT_LINK_REQUESTED,
    label: "Payment link requested",
  },
  {
    id: VOICE_AGENT_OUTCOME.CALL_NOT_ATTEMPTED,
    label: "Call not attempted",
  },
  {
    id: VOICE_AGENT_OUTCOME.NO_ANSWER,
    label: "No answer",
  },
  {
    id: VOICE_AGENT_OUTCOME.NO_ORDER,
    label: "No order",
  },
  {
    id: VOICE_AGENT_OUTCOME.COD_ADDR_UNCONFIRMED,
    label: "COD addr unconfirmed"
  },
  {
    id: VOICE_AGENT_OUTCOME.PREPAID_ADDR_UNCONFIRMED, 
    label: "Prepaid addr unconfirmed"
  },
  {
    id: VOICE_AGENT_OUTCOME.ADDR_INCOMPLETE,
    label: "Addr. incomplete",
  },
];

export enum DISCOUNT_TYPE {
  FIXED_AMOUNT = "fixed",
  PERCENTAGE = "%tage",
}

export interface DiscountConfig {
  code: string;
  description: string;
  value: number;
  codeType: string;
}

export type AiVoiceAgentBackendConfig = {
  type: string;
  sub_type: NodeSubType;
  node_index: number;
  agent_type?: string;
  payment_mode?: string;
  extraParams?: {
    discountConfig?: DiscountConfig;
  };
  conditions: {
    operator: "goto";
    operator_values: { [key: string]: { key: string; value: string } };
  }[];
};

export type AiVoiceAgentFrontendConfig = {
  type: string;
  subType: NodeSubType;
  description: string;
  isMicroFlow: boolean;
  childNodes: { [key: string]: { key: string; value: string } };
};
